import Enumerable from "linq";
import * as Moment from "moment";
import store from "../../../../store";
import { ExecuteRequest, ExternalScriptExecuteResult, ScriptLinkItem } from "../../../../domain/localhost/items";
import { IInternalScriptProcessible } from "../IInternalScriptProcessible";
import { Arguments } from "./Arguments";

export class CurrentDateTimeGetter implements IInternalScriptProcessible {
  public isProcessible(request: ExecuteRequest): boolean {
    const configuration = store.state.configuration.behavior.localhost.internalScript.scripts.currentDateTimeGetter;
    return configuration.isEnable
        && (new RegExp(configuration.pathExpression, "i")).test(this.toModuleName(request.exePath));
  }

  private toArguments(request: ExecuteRequest): Arguments {
    return new Arguments(request.arguments);
  }

  private toModuleName(path: string): string {
    if (!path) { return path; }
    const splitted = path.split("\\");
    return Enumerable.from(splitted).lastOrDefault();
  }

  public async process(request: ExecuteRequest): Promise<ExternalScriptExecuteResult> {
    const args = this.toArguments(request);
    const dateObjectName = args.getValue("-date");
    const timeObjectName = args.getValue("-time");
    const textObjectName = args.getValue("-text");
    return this.toResult(request.scriptLinkItems, dateObjectName, timeObjectName, textObjectName);
  }

  private toResult(scriptLinkItems: ScriptLinkItem[], dateObjectName: string, timeObjectName: string, textObjectName: string): ExternalScriptExecuteResult {
    const result = new ExternalScriptExecuteResult();
    result.isComplete = true;
    result.name = undefined;
    result.values = [];
    result.compressedCsvText = "";
    result.scriptLinkResults = this.toScriptLinkResults(scriptLinkItems, dateObjectName, timeObjectName, textObjectName);
    return result;
  }

  private toScriptLinkResults(scriptLinkItems: ScriptLinkItem[], dateObjectName: string, timeObjectName: string, textObjectName: string): ScriptLinkItem[] {
    const nowDateTime = Moment(new Date());
    const results: ScriptLinkItem[] = [];
    for (const item of scriptLinkItems) {
      if (dateObjectName && item.name === dateObjectName) {
        results.push(this.toClonedItem(item, nowDateTime.format("YYYYMMDD")));
      }
      if (timeObjectName && item.name === timeObjectName) {
        results.push(this.toClonedItem(item, nowDateTime.format("HHmmss")));
      }
      if (textObjectName && item.name === textObjectName) {
        results.push(this.toClonedItem(item, nowDateTime.format("YYYY年M月D日 H時m分")));
      }
    }
    return results;
  }

  private toClonedItem(item: ScriptLinkItem, value: string): ScriptLinkItem {
    const cloned = item.clone();
    cloned.value = value;
    return cloned;
  }
}
